// @flow
import './MetadataTimelineHeader.css';

import * as React from 'react';
import VideoController from './VideoController';
import { toMSS, toSMPTE } from '../util/VideoUtil';
import getTimelineCellConfig from './getTimelineCellConfig';
import * as ReactDOM from 'react-dom';
import Theme from '../basic/Theme';

const debug = require('../debug/debug')('wc:video:MetadataTimelineHeader');

type Props = {
  width: number,
  scale: number,
  controller: VideoController,
  seekChangeEvents: MetadataTimelineSeekChangeEvents
};

type State = {};

export default class MetadataTimelineHeader extends React.Component<Props, State> {
  _node: ?Element;

  state = {};

  renderCell = (t: number, i: number, step: number) => {
    return (
      <g key={i}>
        <line x1={i * step} y1={38} x2={i * step} y2={30} strokeWidth={1} stroke="#696969 " fill="#696969 " />
        <text x={i > 0 ? i * step - 23 : 0} y={25} strokeWidth={0.7}>
          {toSMPTE(t * 1000 + this.props.controller.videoStartTimecode, this.props.controller.frameRate)}
        </text>
      </g>
    );
  };

  onSeekChange = (e: MouseEvent) => {
    const { controller, width, scale } = this.props;
    //$FlowFixMe
    const rect: Element = ReactDOM.findDOMNode(this).getBoundingClientRect();
    const posX = (controller.duration / (width * scale)) * (e.clientX - rect.x);
    debug('[onSeekChange(e)] x = %d scale = %s width = %d', posX, scale, width);
    this.props.seekChangeEvents.onSeekChange(posX);
    this.props.seekChangeEvents.onSeekChangeComplete();
    const duration = controller.duration;
    const cellConfig = getTimelineCellConfig(scale, width, duration);
    const cells = cellConfig.times.map((t, i) => this.renderCell(t, i, cellConfig.step));
    debug('[onSeekChange(e)] cellConfig', cellConfig);
  };

  render() {
    const { controller, width, scale } = this.props;
    const duration = controller.duration;
    const cellConfig = getTimelineCellConfig(scale, width, duration);
    const cells = cellConfig.times.map((t, i) => this.renderCell(t, i, cellConfig.step));

    return (
      <div onClick={(event) => this.onSeekChange(event)}>
        <svg name="MetadataTimelineHeader" style={{ width: scale * width }} ref={(node) => (this._node = node)}>
          {cells}
        </svg>
      </div>
    );
  }
}

export interface MetadataTimelineSeekChangeEvents {
  onSeekChange(time: number): void;

  onSeekChangeComplete(): void;
}
